<template>
    <tfoot v-if="paginationData.total_count > 0" class="table-pagination">
        <tr>
            <td class="table-pagination__row" colspan="20">
                <div class="row">
                    <div class="column-mobile-8">
                        <a class="link link--white" @click="clickPrevHandler" v-if="prevVisible">
                            &lt;
                            <span class="capitalize">{{ $t('common.previous') }}</span>
                        </a>
                        &nbsp;
                    </div>
                    <div class="column-mobile-8 align-center">
                        <div>
                            <b>{{ (paginationData.current_page - 1) * paginationData.per_page + 1 }}</b>
                            {{ $t('common.to') }}
                            <b>
                                {{ (paginationData.current_page - 1) * paginationData.per_page + visibleAmount }}
                            </b>
                            {{ $t('common.from') }}
                            <b>{{ paginationData.total_count }}</b>
                        </div>
                    </div>
                    <div class="column-mobile-8 align-right">
                        &nbsp;
                        <a class="link link--white" @click="clickNextHandler" v-if="nextVisible">
                            <span class="capitalize">{{ $t('common.next') }}</span>
                            &gt;
                        </a>
                    </div>
                </div>
            </td>
        </tr>
    </tfoot>
</template>

<script>
export default {
    props: {
        paginationData: {
            type: Object,
            default: () => {},
        },
        visibleAmount: {
            type: Number,
            default: 0,
        },
        paginationType: {
            type: String,
            default: '',
        },
    },
    computed: {
        prevVisible() {
            return this.paginationData.current_page > 1;
        },
        nextVisible() {
            return this.paginationData.current_page < this.paginationData.total_pages;
        },
    },
    methods: {
        clickPrevHandler() {
            this.$emit('goToPrevPage', this.paginationType);
        },
        clickNextHandler() {
            this.$emit('goToNextPage', this.paginationType);
        },
    },
};
</script>

<style lang="scss">
.table-pagination {
    @include mq($until: mobile-landscape) {
        font-size: 12px;
    }

    &__row {
        position: relative;
        padding: 0 !important;
    }

    .row {
        display: flex;
        align-items: center;
        position: sticky;
        left: 0;
        width: 100vw;
        padding: 5px 15px;

        @include mq(wrapper) {
            width: calc(100vw - #{$sidebar-width});
        }
    }
}
</style>
